/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { SummarySection } from "./SummarySection";
import { SchemaDiffRecord } from "./SchemaDiffRecord";
import { SheetConfig } from "../../sheets/types/SheetConfig";
export const SnapshotSummary = core.serialization.object({
    createdSince: SummarySection,
    updatedSince: SummarySection,
    deletedSince: SummarySection,
    schemaDiff: SchemaDiffRecord,
    config: SheetConfig,
});
